import { render, staticRenderFns } from "./ServiceLaundryPendingQc.vue?vue&type=template&id=680a8fe6&scoped=true"
import script from "./ServiceLaundryPendingQc.vue?vue&type=script&lang=js"
export * from "./ServiceLaundryPendingQc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a8fe6",
  null
  
)

export default component.exports